import type { SquareWithNumbers } from '../../types';

/**
 * Build a 2D grid from a flat array of squares
 */
export function buildGrid(squares: SquareWithNumbers[]): SquareWithNumbers[][] {
  const grid: SquareWithNumbers[][] = [];
  for (let row = 0; row < 10; row++) {
    grid[row] = [];
    for (let col = 0; col < 10; col++) {
      const square = squares.find((s) => s.row === row && s.col === col);
      if (square) {
        grid[row][col] = square;
      }
    }
  }
  return grid;
}
